import { TuandcoProductPageService } from '@/adapters/tuandco-product-page.service';
import { ConfiguratorOptions, DEPENDENCIES } from '@empathybroker/ebx-gluon';

export function rebindContainer({ container }: ConfiguratorOptions) {
  container.rebind(DEPENDENCIES.ProductPageService).to(TuandcoProductPageService);
}
